export default __webpack_public_path__ + "static/media/account-tab-icon.412d23b4.svg";